module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921004149_T.04a9a66f.jpg";